import { useFormikContext } from 'formik';
import React from 'react';
import { Button as ReactButton } from '@a-ui/react';
import { translate } from '../../../i18n';

interface EmailUpdateActionsProps {
  onCancel: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const EmailUpdateActions: React.FC<EmailUpdateActionsProps> = ({ onCancel }) => {
  const { isSubmitting } = useFormikContext();

  return (
    <div className="u-margin-top">
      <ReactButton htmlType="submit" fullWidth disabled={isSubmitting}>
        {translate('common.button.next')}
      </ReactButton>
      <div className="u-margin-top-s">
        <ReactButton emphasis="medium" fullWidth onClick={onCancel}>
          {translate('common.button.cancel')}
        </ReactButton>
      </div>
    </div>
  );
};

export default EmailUpdateActions;
